package org.multiplatform.kotfolio.layout

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.util.Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

val PageContentStyle = CssStyle {
    base { Modifier.fillMaxSize().padding(leftRight = 2.cssRem, top = 4.cssRem, bottom = 4.cssRem) }
    Breakpoint.MD { Modifier.maxWidth(60.cssRem) }
}

private val AMBER_500 = Color.rgb(245, 158, 11)

@Suppress("ParamsComparedByRef")
@Composable
fun BlogLayout(
    pageProperties: PageProperties,
    blogProperties: BlogProperties,
    content: @Composable () -> Unit,
) {
    LaunchedEffect(Unit) {
        js("hljs.highlightAll()")
    }

    LaunchedEffect(pageProperties) {
        updatePageProperties {
            title = pageProperties.title
            description = pageProperties.description
        }
    }

    Box(
        Modifier.fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            PageContentStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            P(
                attrs = Modifier
                    .margin(top = 24.px, bottom = 10.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(35.px)
                    .fontWeight(FontWeight.Black)
                    .color(Colors.Black)
                    .lineHeight(1.2)
                    .toAttrs(),
            ) { Text(blogProperties.title) }

            P(
                attrs = Modifier
                    .margin(bottom = 45.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(25.px)
                    .fontWeight(FontWeight.Bold)
                    .color(AMBER_500)
                    .toAttrs(),
            ) { Text(blogProperties.subTitle) }

            content()
        }
    }
}


